"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _PromptablePropInterface = _interopRequireDefault(require("UIComponents/decorators/PromptablePropInterface"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _PermissionsActions = require("../../actions/PermissionsActions");

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var LANG_ROUTE = 'InboxConnectUtils.optIn';

var OptInFlowContainerModal = function OptInFlowContainerModal(props) {
  var onClick = props.onClick,
      onConfirm = props.onConfirm,
      onReject = props.onReject,
      langKey = props.langKey; // eslint-disable-next-line react/no-multi-comp

  var lang = function lang(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _react.default.createElement(_FormattedHTMLMessage.default, {
      message: LANG_ROUTE + "." + langKey + "." + key,
      options: options
    });
  };

  var handleOptInClick = function handleOptInClick(e) {
    e.preventDefault();

    if (typeof onClick === 'function') {
      onClick();
    }

    onConfirm();
  };

  var cancel = function cancel() {
    return onReject((0, _PermissionsActions.userDeclined)());
  };

  return _react.default.createElement(_UIModal.default, {
    width: 600
  }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
    onClick: cancel
  }), _react.default.createElement(_H.default, null, lang('title'))), _react.default.createElement(_UIDialogBody.default, null, _react.default.createElement("div", {
    style: {
      height: '400px',
      overflowY: 'scroll'
    }
  }, lang('body'))), _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement(_UIButton.default, {
    use: "primary",
    onClick: handleOptInClick,
    className: "m-x-1"
  }, lang('confirmButton')), _react.default.createElement(_UIButton.default, {
    onClick: cancel,
    className: "m-x-1"
  }, lang('cancelButton'))));
};

OptInFlowContainerModal.propTypes = Object.assign({}, _PromptablePropInterface.default, {
  langKey: _propTypes.default.string.isRequired
});
var _default = OptInFlowContainerModal;
exports.default = _default;
module.exports = exports.default;